module.exports = __webpack_public_path__ + "img/img_index_optimization@2x.fbe5059b.png";